import { Box } from '@mui/material';
import { FC, ReactNode } from 'react';

interface Props {
  action: ReactNode;
  children: ReactNode;
}

export const FieldWithAction: FC<Props> = ({ action, children }) => (
  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
    <Box sx={{ flex: 1 }}>{children}</Box>
    {action}
  </Box>
);
